import React from "react";

import { useAppDispatch, useAppSelector } from "store";
import {
    Card,
    CardActionArea,
    CardContent,
    Grid,
    Typography
} from "@material-ui/core";
import { useTheme, withStyles } from "@material-ui/core/styles";

import useColourPalette from "components/visuals/useColourPalette";

import {
    selectSelectedStoreByCostType
} from "modules/customer/insights/cost/costSlice";
import { showFilters } from "modules/customer/insights/cost/filters/filtersSlice";

const StyledCard = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: theme.palette.background.insight,
        borderRadius: 6
    }
}))(Card);

const StyledCardActionArea = withStyles(theme => ({
    root: {
        minHeight: theme.spacing(10)
    }
}))(CardActionArea);

const SelectedStoreOpen: React.FC = () => {
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const colourPalette = useColourPalette();
    const selectedStore = useAppSelector(selectSelectedStoreByCostType);

    const handleClickOpenModal = () => {
        dispatch(showFilters());
    };

    return (
        <StyledCard
            elevation={0}
            variant="outlined"
            data-cy="btn-filters"
        >
            <StyledCardActionArea onClick={handleClickOpenModal}>
                <CardContent>
                    <Grid container direction="column">
                        <Grid container style={{ marginBottom: theme.spacing(1) }} alignItems="center">
                            <Grid item md={4}>
                                <Typography variant="subtitle1" component="div">
                                    Store:
                                </Typography>
                            </Grid>
                            <Grid item md={8}>
                                {selectedStore ? (
                                    <Typography variant="h6" component="div" style={{ color: colourPalette.comparators[0] }}>
                                        {selectedStore?.storeName}
                                    </Typography>
                                ) : (
                                    <Typography variant="h6" component="div" style={{ color: theme.palette.text.secondary }}>
                                        Unselected
                                    </Typography>
                                )}
                            </Grid>
                        </Grid>
                        <Grid container alignItems="center">
                            <Grid item md={4}>
                                <Typography variant="subtitle1" component="div">
                                    Cost type:&nbsp;&nbsp;
                                </Typography>
                            </Grid>
                            <Grid item md={8}>
                                {selectedStore ? (
                                    <Typography variant="h6" component="div" style={{ color: colourPalette.comparators[0] }}>
                                        {selectedStore?.costName}
                                    </Typography>
                                ) : (
                                    <Typography variant="h6" component="div" style={{ color: theme.palette.text.secondary }}>
                                        Unselected
                                    </Typography>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>
            </StyledCardActionArea>
        </StyledCard>
    );
};

export default SelectedStoreOpen;
